module.exports = __webpack_public_path__ + "assets/img/num3.298673cd.png";